<template>
    <div class="cover-konten">
        <!-- konten share -->
        <div class="share-content">
            <div id='isi-share'>
                <textarea id='textarea' placeholder="Surah"></textarea>
                <button @click="handleCopy()" title="Copy" class='btn btn-primary mt-3' type='button'><i class="fa fa-copy"></i> Copy</button>
            </div>
        </div>
        <!-- end share -->
        <div class='container baca mt-5' v-if="status === false">
            <div v-for="result in data" class="isi-bacaan" v-bind:key="result.nomor">
                <div id='row-1'>
                    <button v-bind:key="result.nomor" class="btn-share" type='button'><i class="fa fa-share"></i></button>
                </div>
                <div id='row-2'>
                    <p>
                        {{result.ar}}
                    </p>
                </div>
                <div id='row-3'>
                   <div class="col-row3">
                       <label id='nomor-ayat'>{{result.nomor}}</label>
                   </div>
                   <div class="arti-ayat">
                       <span id='bhs-arab' v-html="result.tr"></span>
                        <p>
                       {{result.id}}
                    </p>
                   </div>
                </div>
            </div>


        </div>
        <!-- loader -->
        <div v-bind:class="{coverLoader : status, hide: fade}">
            <button v-bind:class="{'btn-spin': status, hide: fade }" type='button'></button>
        </div>
        <button class='btn-playing' @click="handleChange()" type='button'><i class='iC fa fa-play'></i></button>
    </div>
</template>
<style lang="css" scoped>
    #textarea 
    {
        width: 100%;
        height: 350px;
        padding: 2%;
        border-radius: 5px;
        border: 1px solid #dfd3d3;
    }
    .share-content
    {
        position: fixed;
        z-index: 5000;
        width: 100%;
        height: 100%;
        top: -200%;
        left: 0;
        background-color: rgba(0,0,0,0.7);
        display: flex;
        justify-content: center;
        align-items: center;
        transition: 0.4s;
    }
    .show-share 
    {
        top: 0;
        transition: 0.4s;
    }
    #isi-share 
    {
        width: 60%;
        min-height: 400px;
        background-color: white;
        border-radius: 5px;
        border: 1px solid transparent;
        padding: 2%;
    }
    @media screen and (max-width: 780px)
    {
        #isi-share 
        {
            width: 90%;
        }
    }
    .btn-playing 
    {
        position: fixed;
        z-index: 300;
        right: 4%;
        bottom : 25%;
        width: 30px;
        height: 30px;
        border-radius: 50px;
        font-size: 11px;
        border: 1px solid #4de498;
        background-color: #4de498;
        color: white;
        box-shadow: 0px 0px 20px 1px #4de498;
        transition: 0.3s;
    }
    .btn-playing:focus{
        outline: none;
    }
    .btn-playing:hover{
        box-shadow: 0px 0px 30px 10px #4de498;
    }
    .hide
    {
        display: none;
    }
    .coverLoader 
    {
        width: 100%;
        height: 100%;
        position: fixed;
        z-index: 2000;
        background-color: white;
        justify-content: center;
        align-items: center;
        display: flex;
        top: 0;
    }
    .btn-spin 
    {
        width: 50px;
        height: 50px;
        border-radius: 50px;
        border: 3px solid transparent;
        border-left-color: blue;
        background-color: transparent;
        animation: 1s putar linear infinite;
    }
    @keyframes putar 
    {
        from 
        {
            transform: rotate(0deg);
        }to 
        {
            transform: rotate(360deg);
        }
    }
    .baca 
    {
        margin-bottom: 15%;
    }
    .isi-bacaan 
    {
        width: 100%;
        height: auto;
        border-bottom: 1px solid #dfd3d3;
        display: block;
        margin-top: 2%;
        padding: 2% 0% 2% 0%;
    }
    #row-1 
    {
        width: 100%;
        text-align: right;
    }
    #row-2 
    {
        text-align: right;
        margin-top: 2%;
        font-size: 35px;
    }
    .btn-share 
    {
        border: none;
        background-color: transparent;
        color: gray;
    }
    #row-3
    {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .col-row3
    {
        width: 5%;
        height: auto;
        font-weight: bold;
    }
    .arti-ayat 
    {
        width: 95%;
    }
    .arti-ayat p 
    {
        margin: 0;
        line-height: 30px;
    }
    #nomor-ayat 
    {
        font-size: 18px;
        font-weight: bold;
    }
    #bhs-arab {
        font-weight: bold;
        margin-bottom: 4%;
    }
    @media screen and (max-width: 780px)
    {
        .btn-playing
        {
            bottom : 28%;
            right: 5.8%;
        }
        .baca 
        {
            margin-bottom: 45%;
        }
    }

</style>

<script>
import axios from 'axios';
import { bus } from '../main';
import { Write, Read }  from './Cookies';

export default{
    data(){
        return {
            proxy: 'https://cors-anywhere.herokuapp.com/',
            url: 'https://al-quran-8d642.firebaseio.com/surat/'+ this.$route.params.nomor +'.json?print=pretty',
            data: [],
            nomor: this.$route.params.nomor,
            status: true,
            fade: false,
            sources: [],
            url2: 'https://al-quran-8d642.firebaseio.com/data.json?print=pretty',
        }
    },
    created(){
        document.title = this.$route.params.nama;
        axios.get(`${this.proxy}${this.url}`)
        .then(res => {
            if( this.$route.params.nomor > 0 )
            {
                if( res.data !== null )
                {
                    this.status = false;
                    this.fade = true;
                    this.data = res.data;
                    new Write('surat', this.$route.params.nama, 30);
                    new Write('arti', this.$route.params.arti, 30);
                    new Write('nomor', this.$route.params.nomor, 30);
                    
                }else
                {
                    window.location.href = "/";
                }
            }else
            {
                window.location.href = "/";
            }
        });
        
    },
    methods : {
        handleChange()
        {
            bus.$emit('AddData', this.nomor);
        },
        share(params){
            const share = document.querySelector('.share-content');
            const text = document.querySelector('#textarea');
            text.value = params.trim();
            share.classList.toggle('show-share');
        },
        handleCopy(){
            const text = document.querySelector('#textarea');
            const share = document.querySelector('.share-content');
            text.select();
            document.execCommand('copy');
            share.classList.remove('show-share');
        },
    },
    mounted(){
        setTimeout(() => {
            const btn = document.querySelectorAll('.btn-share');
            const el = document.querySelectorAll('.isi-bacaan');

            for(let i = 0; i < btn.length; i++)
            {
                btn[i].addEventListener('click', () => {
                    this.share(el[i].textContent);
                })
            }

        },4000)
    }
}
</script>